import { useCallback } from 'react';
import { dateUtils } from 'scbk-shared-module/utils';
import writeExcelFile from 'write-excel-file/browser';
import { tableToSheetData } from '../utils/tableToSheetData';

/**
 *
 */
type DownloadTableOptions = {
  fileName?: string;
  sheetName?: string;
};

/**
 * 엑셀다운로드 훅 함수
 */
const useExcelDownload = () => {
  /**
   * 테이블 HTML을 엑셀로 변환하여 다운로드한다.
   * @param table HTMLTableElement
   * @param options
   */
  const downloadTableToExcel = useCallback(
    async (table: HTMLTableElement | null, options?: DownloadTableOptions) => {
      if (!table) {
        return;
      }

      const sheetData = tableToSheetData(table);
      const fileName = `${options?.fileName ?? '다운로드'}_${dateUtils.getToday()}.xlsx`;

      await writeExcelFile(sheetData, {
        sheet: options?.sheetName ?? 'Sheet1',
      }).toFile(fileName);
    },
    [],
  );

  return { downloadTableToExcel };
};

export { useExcelDownload };
